// ChatOnlyPage — minimalist full-screen chat view opened from the
// "Messagerie" CTA on the ClientDashboard. Strips away every block
// shown on the public TrackingPage (driver card, payment banner,
// "Appeler le chauffeur", "Signaler un problème") so the client lands
// DIRECTLY inside the conversation with the driver. The tracking token
// stays the same shared-secret as TrackingPage so we don't need a new
// backend endpoint.

import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ChatBox from "@/components/ChatBox";

export default function ChatOnlyPage() {
  const { token } = useParams();
  const navigate = useNavigate();

  return (
    <div
      className="flex min-h-[100dvh] flex-col overflow-x-hidden bg-background"
      style={{ maxWidth: "100vw" }}
    >
      {/* Top bar — back arrow + title, kept slim so the chat takes
          the entire viewport on mobile. */}
      <header
        className="sticky top-0 z-10 flex items-center gap-3 border-b border-border/60 bg-background/95 px-4 py-3 backdrop-blur"
        style={{ paddingTop: "max(12px, env(safe-area-inset-top))" }}
      >
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="-ml-1 grid h-9 w-9 flex-none place-items-center rounded-full bg-secondary text-foreground hover:bg-secondary/80"
          style={{ touchAction: "manipulation" }}
          data-testid="chat-back"
          aria-label="Retour"
        >
          <ArrowLeft className="h-4 w-4" />
        </button>
        <div className="min-w-0 flex-1 overflow-hidden">
          <p className="text-[10px] font-medium uppercase tracking-[0.18em] text-primary/70">Saor</p>
          <h1 className="truncate font-[Outfit] text-base font-semibold leading-tight tracking-tight text-foreground">
            Messagerie de la course
          </h1>
        </div>
      </header>

      <main
        className="flex flex-1 flex-col overflow-hidden px-4 pb-4 pt-3"
        style={{ paddingBottom: "max(16px, env(safe-area-inset-bottom))" }}
      >
        <div className="min-h-0 flex-1">
          <ChatBox token={token} author="client" label="Messagerie" />
        </div>
      </main>
    </div>
  );
}
